import './sponsored-results.css';

import '../../sstk-resource-grid.css';
